import React from "react";
import "./V2SchoolErrorMessage.css";

interface V2SchoolErrorMessageProps {
  isIndividualReg: boolean;
  schoolName?: string;
  errorType: "access" | "registration_closed" | "general";
  customMessage?: string;
}

const V2SchoolErrorMessage: React.FC<V2SchoolErrorMessageProps> = ({
  isIndividualReg,
  schoolName,
  errorType,
  customMessage,
}) => {
  const getErrorMessage = () => {
    if (customMessage) return customMessage;

    switch (errorType) {
      case "access":
        return isIndividualReg
          ? "Unable to access registration. Please contact support."
          : `Unable to access registration for ${schoolName}. Please contact your school authorities.`;

      case "registration_closed":
        return isIndividualReg
          ? "Individual registrations are now closed."
          : `Registrations for ${schoolName} are now closed.`;

      case "general":
      default:
        return isIndividualReg
          ? "An error occurred. Please try again or contact support."
          : `An error occurred with ${schoolName} registration. Please contact your school authorities.`;
    }
  };

  const getContactInfo = () => {
    return isIndividualReg
      ? "support@nationalfinanceolympiad.com"
      : "your school authorities";
  };

  return (
    <div className="v2-error-container">
      <div className="v2-error-icon">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            fill="#d32f2f"
          />
        </svg>
      </div>
      <div className="v2-error-message-container">
        <h3 className="v2-error-title">Registration Issue</h3>
        <p className="v2-error-message">{getErrorMessage()}</p>
        <p className="v2-error-contact">
          For further assistance, please contact{" "}
          <strong>{getContactInfo()}</strong>.
        </p>
      </div>
    </div>
  );
};

export default V2SchoolErrorMessage;
